export const SOURCES_MOCKS = [
  {
    'type': 'file',
    'name': 'Tesco FY2025/26 Strategy Update · Oct 2025',
    'title': 'Focus on "Save to Invest" program - cutting opera',
    'summary': 'Emphasis on "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'url',
    'name': 'Financial News → Interview with Ken Murphy (CEO)',
    'title': 'Quote: "Cyber security is top of my inbox"',
    'summary': 'Prioritize "Smart Operations" – Automating key processes to accelerate digital growth. Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation.',
    'logo': 'https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg'
  },
  {
    'type': 'graph',
    'name': 'Gartner Market Guide · Jan 2026',
    'title': 'Retail Cybersecurity & Vendor Consolidation Tren',
    'summary': 'Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation. Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'api',
    'name': 'Market Insights → Panel Discussion with Lisa Tran',
    'title': 'Quote: "Sustainability must be at the core of corp',
    'summary': 'Focus on "Green Technologies" – Investing in renewable energy to drive innovation.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Industry Trends → Webinar featuring James Lee',
    'title': 'Quote: "AI is reshaping our approach to customer',
    'summary': 'Emphasize "Customer-Centric Solutions" – Leveraging data to enhance service delivery.',
  },
  {
    'type': 'file',
    'name': 'Tesco FY2025/26 Strategy Update · Oct 2025',
    'title': 'Focus on "Save to Invest" program - cutting opera',
    'summary': 'Emphasis on "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'api',
    'name': 'Financial News → Interview with Ken Murphy (CEO) ·',
    'title': 'Quote: "Cyber security is top of my inbox"',
    'summary': 'Prioritize "Smart Operations" – Automating key processes to accelerate digital growth.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Gartner Market Guide · Jan 2026',
    'title': 'Retail Cybersecurity & Vendor Consolidation Tren',
    'summary': 'Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation. Prioritize "Smart Operations" – Automating key processes to accelerate digital growth. Prioritize "Smart Operations" – Automating key processes to accelerate digital growth.',
    'logo': 'https://www.google.com/s2/favicons?domain=google.com&sz=128'
  },
  {
    'type': 'url',
    'name': 'Market Insights → Panel Discussion with Lisa Tran (C',
    'title': 'Quote: "Sustainability must be at the core of corp',
    'summary': 'Focus on "Green Technologies" – Investing in renewable energy to drive innovation.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Industry Trends → Webinar featuring James Lee (CT',
    'title': 'Quote: "AI is reshaping our approach to customer',
    'summary': 'Emphasize "Customer-Centric Solutions" – Leveraging data to enhance service delivery.',
  },
  {
    'type': 'file',
    'name': 'Tesco FY2025/26 Strategy Update · Oct 2025',
    'title': 'Focus on "Save to Invest" program - cutting opera',
    'summary': 'Emphasis on "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'url',
    'name': 'Financial News → Interview with Ken Murphy (CEO) ·',
    'title': 'Quote: "Cyber security is top of my inbox"',
    'summary': 'Prioritize "Smart Operations" – Automating key processes to accelerate digital growth. Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Gartner Market Guide · Jan 2026',
    'title': 'Retail Cybersecurity & Vendor Consolidation Tren',
    'summary': 'Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation. Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'api',
    'name': 'Market Insights → Panel Discussion with Lisa Tran (C',
    'title': 'Quote: "Sustainability must be at the core of corp',
    'summary': 'Focus on "Green Technologies" – Investing in renewable energy to drive innovation.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Industry Trends → Webinar featuring James Lee (CT',
    'title': 'Quote: "AI is reshaping our approach to customer',
    'summary': 'Emphasize "Customer-Centric Solutions" – Leveraging data to enhance service delivery.',
  },
  {
    'type': 'file',
    'name': 'Tesco FY2025/26 Strategy Update · Oct 2025',
    'title': 'Focus on "Save to Invest" program - cutting opera',
    'summary': 'Emphasis on "Efficiency First" - Streamlining workflows to boost digital transformation.',
  },
  {
    'type': 'api',
    'name': 'Financial News → Interview with Ken Murphy (CEO) ·',
    'title': 'Quote: "Cyber security is top of my inbox"',
    'summary': 'Prioritize "Smart Operations" – Automating key processes to accelerate digital growth.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Gartner Market Guide · Jan 2026',
    'title': 'Retail Cybersecurity & Vendor Consolidation Tren',
    'summary': 'Emphasize "Efficiency First" - Streamlining workflows to boost digital transformation. Prioritize "Smart Operations" – Automating key processes to accelerate digital growth. Prioritize "Smart Operations" – Automating key processes to accelerate digital growth.',
  },
  {
    'type': 'url',
    'name': 'Market Insights → Panel Discussion with Lisa Tran (C',
    'title': 'Quote: "Sustainability must be at the core of corp',
    'summary': 'Focus on "Green Technologies" – Investing in renewable energy to drive innovation.',
    'logo': 'https://brandfetch.com/techcrunch.com?format=png'
  },
  {
    'type': 'graph',
    'name': 'Industry Trends → Webinar featuring James Lee (CT',
    'title': 'Quote: "AI is reshaping our approach to customer',
    'summary': 'Emphasize "Customer-Centric Solutions" – Leveraging data to enhance service delivery.',
  }
]

export const WIDGETS_MOCKS = [
  {
    type: 'kpi',
    title: 'MOBILE SUBSCRIBERS',
    value: '58.4M',
    direction: 'up',
    explanation: 'Total active mobile subscription count'
  },
  {
    type: 'kpi',
    title: 'MOBILE ARPU',
    value: '₱155',
    direction: 'down',
    explanation: 'Average revenue per user'
  },
  {
    type: 'kpi',
    title: 'MOBILE SUBSCRIBERS',
    value: '58.4M',
    direction: 'up',
  },
  {
    type: 'kpi',
    title: 'MOBILE ARPU',
    value: '₱155',
    direction: 'down',
  },
  {
    type: 'kpi',
    title: 'MOBILE SUBSCRIBERS23423423423423',
    value: '$4.26B123',
    direction: 'up',
    explanation: 'Total active mobile subscription count'
  },
  {
    type: 'kpi',
    title: 'MOBILE ARPU',
    value: '₱155',
    direction: 'down',
    explanation: 'Average revenue per user'
  },
  {
    type: 'orgmap',
    markdown: '# Organization Map',
    children: [
      {
        shared_contact_id: 'contact-john-stankey',
        name: '[John Stankey](entity://contact/contact-john-stankey)',
        title: 'Chairman, CEO & President',
        children: [
          {
            user_contact_id: 'contact-jeff-mcelfresh',
            logo_uri: 'assets/guy.png',
            name: '[Jeff McElfresh](entity://contact/contact-jeff-mcelfresh)',
            title: 'Chief Operating Officer',
            children: [
              {name: 'Melissa Arnoldi', title: 'EVP & GM - AT&T Business'},
              {
                shared_contact_id: 'contact-jenifer-robertson',
                name: '[Jenifer Robertson](entity://contact/contact-jenifer-robertson)',
                title: 'EVP & GM - AT&T Consumer / Mass Markets'
              },
              {
                name: 'Corey Anthony',
                title: 'SVP - Network Engineering & Operations',
                children: [
                  {name: '[Gordon Mansfield](entity://contact/contact-gordon-mansfield)', title: 'VP - Global Technology Planning & Engineering'},
                  {name: '[Robert Soni](entity://contact/contact-robert-soni)', title: 'VP - Radio Access Network Technology'},
                  {name: 'Alisha Remek', title: 'VP - Access Construction & Engineering'}
                ]
              }
            ]
          }
        ]
      }
    ]
  },
]

export const QUESTION_VSELECT_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Create a report about Gil Rosen',
      title: 'Create a report about Gil Rosen'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        type: 'vertical_select',
        title: 'Should I run a full persona analysis on Gil Rosen?',
        state: 'cde17682-ef75-4881-b911-249b489f2104',
        can_input: true,
        on_skip: {text: 'user did not make a choice'},
        items: [
          // list of chat query
          {text: 'Yes', title: 'Yes'},
          {text: 'Create a snapshot persona analysis for Gil Rosen', title: 'Snapshot'},
          {text: 'Create a sales brief persona analysis for Gil Rosen', title: 'Sales brief'}
        ]
      }
    }
  }
]


export const QUESTION_BUTTONS_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Help me prioritize the Tesco account plan',
      title: 'Help me prioritize the Tesco account plan'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        title: 'Which direction should I optimize for?',
        type: 'buttons',
        items: [
          {title: 'Growth', type: 'accept', chat_query: {text: 'Prioritize growth opportunities', title: 'Growth'}},
          {title: 'Risk', type: 'reject', chat_query: {text: 'Prioritize account risks and blockers', title: 'Risk'}}
        ]
      }
    }
  }
]

export const QUESTION_SELECT_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Create outreach for Ken Murphy',
      title: 'Create outreach for Ken Murphy'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        title: 'Which angle should I use?',
        type: 'select',
        items: [
          {title: 'Operational efficiency', chat_query: {text: 'Use an operational efficiency angle', title: 'Operational efficiency'}},
          {title: 'Cybersecurity resilience', chat_query: {text: 'Use a cybersecurity resilience angle', title: 'Cybersecurity resilience'}},
          {title: 'Customer experience', chat_query: {text: 'Use a customer experience angle', title: 'Customer experience'}}
        ],
        skip: {chat_query: {text: 'Choose the strongest outreach angle for me', title: 'Choose for me'}}
      }
    }
  }
]

export const QUESTION_MULTISELECT_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Build a meeting brief for Tesco',
      title: 'Build a meeting brief for Tesco'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        title: 'What should the brief include?',
        type: 'multiselect',
        items: [
          {title: 'Recent news', chat_query: {text: 'Include recent news', title: 'Recent news'}},
          {title: 'Executive priorities', chat_query: {text: 'Include executive priorities', title: 'Executive priorities'}},
          {title: 'Open risks', chat_query: {text: 'Include open risks', title: 'Open risks'}},
          {title: 'Suggested next steps', chat_query: {text: 'Include suggested next steps', title: 'Suggested next steps'}}
        ],
        skip: {chat_query: {text: 'Use the default meeting brief sections', title: 'Default sections'}}
      }
    }
  }
]

export const QUESTION_TEXT_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Draft a follow-up email',
      title: 'Draft a follow-up email'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        title: 'What was the main topic from the meeting?',
        type: 'text',
        chat_query: {title: 'Meeting topic'},
        skip: {chat_query: {text: 'Use a general follow-up topic', title: 'General topic'}},
        skip_all: {chat_query: {text: 'Write the follow-up without more questions', title: 'Skip all'}}
      }
    }
  }
]

export const QUESTION_PROFILE_SELECT_MOCK_HISTORY = [
  {
    type: 'user',
    data: {
      text: 'Find the best contact for Tesco outreach',
      title: 'Find the best contact for Tesco outreach'
    }
  },
  {
    type: 'assistant',
    intermediate: true,
    data: {
      question: {
        title: 'Which contact should I use?',
        type: 'profile_select',
        items: [
          {
            title: 'Ken Murphy - Group Chief Executive',
            linkedin_url: 'https://www.linkedin.com/company/tesco',
            url: 'https://www.tesco.com',
            chat_query: {text: 'Use Ken Murphy as the target contact', title: 'Ken Murphy'}
          },
          {
            title: 'Technology leadership contact',
            url: 'https://www.tesco.com',
            chat_query: {text: 'Use the technology leadership contact', title: 'Technology leadership'}
          }
        ],
        skip: {chat_query: {text: 'Choose the best contact for me', title: 'Choose for me'}},
        skip_all: {chat_query: {text: 'Continue without selecting a contact', title: 'No contact'}}
      }
    }
  }
]
